import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import { AssignLeadListLayer } from '../components/leads/AssignLeadListLayer'

export const AssignLeadListPage = () => {
  return (
    <MasterLayout>
        <AssignLeadListLayer/>
    </MasterLayout>
  )
}
